import { RepositoryPickerActions } from "DistributedTaskControls/Actions/RepositoryPickerActions";
import { ActionsHubManager } from "DistributedTaskControls/Common/Actions/ActionsHubManager";
import * as Base from "DistributedTaskControls/Common/Components/Base";
import * as StoreCommonBase from "DistributedTaskControls/Common/Stores/Base";
import {
    StoreKeys
} from "DistributedTaskControls/SharedControls/InputControls/RepositoryPickerConstants";

export interface IRepositoryPickerState extends Base.IState {
    value: string;
    showRepositorySelectorDialog: boolean;
    initialValues: string[];
}

export class RepositoryPickerStore extends StoreCommonBase.StoreBase {

    constructor(args: IRepositoryPickerState) {
        super();
        this._state.value = args.value;
        this._state.showRepositorySelectorDialog = args.showRepositorySelectorDialog;
        this._state.initialValues = args.initialValues;
    }

    public initialize(instanceId: string): void {
        this._repositoryPickerActions = ActionsHubManager.GetActionsHub<RepositoryPickerActions>(RepositoryPickerActions, instanceId);
        this._repositoryPickerActions.updateValue.addListener(this._onUpdateValue);
        this._repositoryPickerActions.updateShowRepositorySelectorDialog.addListener(this._onUpdateShowRepositorySelectorDialog);
    }

    public static getKey(): string {
        return StoreKeys.RepositoryPicker;
    }

    public getState(): IRepositoryPickerState {
        return this._state;
    }

    protected disposeInternal(): void {
        this._repositoryPickerActions.updateValue.removeListener(this._onUpdateValue);
        this._repositoryPickerActions.updateShowRepositorySelectorDialog.removeListener(this._onUpdateShowRepositorySelectorDialog);
    }

    private _onUpdateValue = (value: string): void => {
        this._state.value = value;
        this.emitChanged();
    }

    private _onUpdateShowRepositorySelectorDialog = (showRepositorySelectorDialog: boolean): void => {
        this._state.showRepositorySelectorDialog = showRepositorySelectorDialog;
        this.emitChanged();
    }

    private _state: IRepositoryPickerState = {} as IRepositoryPickerState;
    private _repositoryPickerActions: RepositoryPickerActions;
}
